import React from "react";

export default function MainTermsBox({
  id,
  src,
  top,
  right,
  termsName,
  isSelect = false,
  setTermsIndex
}) {
  return (
    <div
    data-id={id}
      style={{
        top: `${top}px`,
        right: `${right}px`,
      }}
      className={`absolute w-[65px] h-[63px] ${
        isSelect
          ? "rounded-[15px] bg-[#fec62b8e] scale-125"
          : "rounded-[40px] bg-[#e5e5e5a4]"
      }   flex items-center justify-center cursor-pointer p-[8px] `}
      onClick={(e)=>{
        setTermsIndex(parseInt(e.target.dataset.id))
      }}
    >
      {isSelect && (
        <span
          className={`scale-75 absolute font-font_primary_A text-[16px] font-medium text-[#000000] left-[-100px]  top-1/2 -translate-y-1/2`}
        >
          {termsName}
        </span>
      )}

      <img  data-id={id} src={src} className="w-[50px] h-[50px]" />
    </div>
  );
}
